import { SimpleTenant } from '../models/simple-tenant.model';

// Only the church's default Calendar entry uses this preference. Explicit CMS
// calendars and reservation routes retain their own destinations and filters.
export function churchCalendar(tenant: Pick<SimpleTenant, 'subdomain' | 'customCalendar'>): { url: string; external: boolean } {
  const custom = tenant?.customCalendar?.trim();
  return custom ? { url: custom, external: true } : {
    url: '/' + tenant.subdomain + '/admin/cms/calendar/0/0/1', external: false
  };
}
